// extracted by mini-css-extract-plugin
module.exports = {"component":"article-video_component__1hrnz","iframe":"article-video_iframe__25mjH","caption":"article-video_caption__wMKmt"};